<template>
  <div
    class="card"
    :data-min-from-last-mandatory="step.period || 0"
    :data-is-mandatory="step.is_mandatory || 0"
  >
    <header class="card-header">
      <div class="card-header-title">
        <h4>
          <span
            v-if="step.name"
            class="step-title"
          >{{ step.name }}</span>
          <span v-else><i>Please add a name to this step</i></span>
        </h4>
      </div>
      <a
        class="card-header-icon card-toggle"
        @click="toggleElement($event)"
      >
        <i class="fas fa-angle-down fa-fw" /> &nbsp;<span data-toggle="Close">View</span>
      </a>
    </header>
    <div class="card-content is-hidden">
      <div class="content">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label
              v-if="step.type_name"
              class="label"
            >Type of action</label>
            <label
              v-else
              class="label"
            >Possible types of action</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div
                v-if="step.type_name"
                class="control"
              >
                {{ step.type_name }}
              </div>
              <div v-else>
                <template v-for="(choice_option) in step.possible_choices_list">
                  &bull; {{ choice_option.name }}&nbsp;
                </template>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Template</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                {{ step.template_id }}
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="index > 0"
          class="field is-horizontal"
        >
          <div class="field-label is-normal">
            <label class="label">Number of day(s) from previous step</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control">
                <template v-if="step.period">
                  {{ step.period }}
                </template><template v-else>
                  0
                </template>&nbsp;
                (Total from start: <span class="total-from-start">
                  <template v-if="step.sum_days">{{ step.sum_days }}</template>
                  <template v-else>0</template>
                </span> days)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'WorkflowStepViewComponent',
  props: {
    step: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    toggleElement(event) {
      const el = event.currentTarget;
      el.closest('.card').querySelector('.card-content').classList.toggle('is-hidden');
      el.querySelector('i').classList.toggle('fa-angle-down');
      el.querySelector('i').classList.toggle('fa-angle-up');
      const currentHTML = el.querySelector('span').innerHTML;
      el.querySelector('span').innerHTML = el.querySelector('span').getAttribute('data-toggle');
      el.querySelector('span').setAttribute('data-toggle', currentHTML);
    }
  }
};
</script>
